import type { ApiABExperiment } from 'api/abExperiment/types/ApiABExperiment';

export function getAnalyticsAbExperimentsConcatenatedString(
  experiments: ApiABExperiment[],
): string | undefined {
  if (experiments.length === 0) return;

  return `"${experiments.map((e) => `${e.id}=${e.bucket}`).join('"&"')}"`;
}
